import React from 'react';
import { Divider, Row } from 'antd';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';
import styles from './rec_a.css';

class RecA extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        console.log("RecA", this.props);
        const itemList = this.props.data.map((item) => {
            const { pic, novel_id, name, cata, author, brief, } = item;
            return <Link to={`/book/detail/${novel_id}`} key={novel_id}>
                <div className={styles.wrap_content_item}>
                    <div style={{ height: '270px', width: '212px', overflow: "hidden", position: 'relative' }}>
                        <img alt='' src={pic} className={styles.hover_img} />
                        <img alt='' src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ position: 'absolute', left: '0', top: '0', width: '100px' }} />
                    </div>
                    <div style={{ flex: 1, marginLeft: '20px' }}>
                        <div style={{ maxWidth: '260px', fontSize: '16px', lineHeight: '22px', color: '#333333', margin: '20px 0 0', }}>
                            <LinesEllipsis maxLine={1} text={name} title={name} />
                        </div>
                        <div style={{ fontSize: '14px', lineHeight: '20px', color: '#999999', textAlign: 'left' }}>
                            {cata}{author && <span><Divider type="vertical" />{author}</span>}
                        </div>
                        <div style={{ fontSize: '14px', lineHeight: '20px', color: '#333333', margin: '20px 0 0' }}>
                            <LinesEllipsis text={brief} maxLine={8} title={brief} />
                        </div>
                    </div>
                </div>
            </Link>;
        });
        return (
            <div className={styles.wrap}>
                <h3>&gt;&gt;重磅推荐！</h3>
                <div className={styles.wrap_content}>
                    {itemList}
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Link to={'/category'}>
                        <span style={{ color: '#333333', fontSize: '14px' }}>查看更多&gt;</span>
                    </Link>
                </div>
            </div >
        )
    }
}


export default RecA;


// WEBPACK FOOTER //
// ./src/component/rec/rec_a.js